<script lang="ts">
  import type { GpuPluginHost } from "../host.js";
  import CatalogBrowser from "./CatalogBrowser.svelte";

  interface Props {
    host: GpuPluginHost;
  }

  let { host }: Props = $props();
</script>

<CatalogBrowser {host} tab="hf" />
